<template>
  <div id="weather">
    <div class="container">
      <h1>Weather</h1>
      <p>Click the map below to select your weather location.</p>
      <div id="map"></div>
      <form @submit.prevent class="mt-4">
        <label>Weather Links</label>
        <div class="form-group">
          <div
            class="row mb-1"
            v-for="(link, index) in links"
          >
            <div class="col">
              <input
                v-model="link.text"
                type="text"
                class="form-control"
                placeholder="Link Text"
              >
            </div>
            <div class="col">
              <input
                v-model="link.url"
                type="text"
                class="form-control"
                placeholder="Link URL"
              >
            </div>
            <div class="col-1">
              <b-btn
                class="btn-danger"
                @click="removeLink(index)"
              >
                <i class="fas fa-minus"></i>
              </b-btn>
            </div>
          </div><!-- /.row -->
        </div><!-- /.form-group -->
        <b-btn
          @click="addLink()"
        >Add Link</b-btn>
      </form>
      <button
        class="btn btn-primary mb-4 mt-4"
        @click="saveSettings()"
      >
        Save Settings
      </button>
    </div><!-- /.container -->
  </div><!-- /#trailHub -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../../firebaseConfig.js')
import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'

export default {
  data() {
    return {
      links: []
    }
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  mounted() {
    this.initMap()
  },
  methods: {
    removeLink(index) {
      this.links.splice(index, 1)
    },
    addLink() {
      this.links.push({
        text: '',
        url: ''
      })
    },
    saveSettings() {
      this.dashboard.data.modules.weather.links = this.links
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully updated settings!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      }).catch(err => {
        console.log(err.message)
      })
    },
    initMap() {
      let self = this
      if (self.dashboard.data.modules.weather.links) {
        self.links = self.dashboard.data.modules.weather.links
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoib3JiaXRpc3QiLCJhIjoiYnpUTnJBdyJ9.uxgaJ0R9ZNsCcEnPNfo2ag';
      const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/orbitist/ck3t7i0ht3kx61cljkerwl09f',
        center: [0, 0],
        zoom: 1
      })

      map.scrollZoom.disable()

      map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')

      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        marker: false
      })
      map.addControl(geocoder)
      geocoder.on('result', function(results) {
        console.log(results);
      })

      // CLICK TO ADD MARKER
      let selectMarker = null

      function addMarker(e) {
        if (selectMarker != null) {
          selectMarker.remove()
        }
        let markerOptions = e
        markerOptions.color = 'orange'
        // markerOptions.draggable = true
        selectMarker = new mapboxgl.Marker(markerOptions)
          .setLngLat(e.lngLat)
          .addTo(map)
        console.log(e)
        self.dashboard.data.modules.weather.lng = e.lngLat.lng
        self.dashboard.data.modules.weather.lat = e.lngLat.lat
        console.log(self.dashboard.data.modules.weather)
      }

      map.on('click', addMarker)
      addMarker({lngLat: {
        lng: self.dashboard.data.modules.weather.lng,
        lat: self.dashboard.data.modules.weather.lat
      }})

    }
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/modules/Weather.vue